import { Injectable } from '@angular/core';

import { ActionsSubject, select, Store } from '@ngrx/store';

import { common } from '@qwyk/models';

import { CustomViewsUiActions } from './custom-views-ui.actions';
import * as CustomViewsSelectors from './custom-views-ui.selectors';

@Injectable()
export class CustomViewsUiFacade {
    /**
     * Combine pieces of state using createSelector,
     * and expose them as observables through the facade.
     */
    loading$ = this.store.pipe(
        select(CustomViewsSelectors.getCustomViewsLoading)
    );

    allCustomViews$ = this.store.pipe(
        select(CustomViewsSelectors.getAllCustomViews)
    );

    selectedView$ = this.store.pipe(select(CustomViewsSelectors.getSelected));

    error$ = this.store.pipe(select(CustomViewsSelectors.getCustomViewsError));

    constructor(
        private store: Store,
        private actionsListener$: ActionsSubject
    ) {}

    /**
     * Use the initialization action to perform one
     * or more tasks in your Effects.
     */
    init() {
        this.store.dispatch(CustomViewsUiActions.init());
    }

    public addNewCustomView(parent: string, request: common.CustomView) {
        this.store.dispatch(
            CustomViewsUiActions.createCustomView({ parent, request })
        );
    }

    public updateCustomView(
        parent: string,
        request: Partial<common.CustomView>
    ) {
        this.store.dispatch(
            CustomViewsUiActions.updateCustomView({ parent, request })
        );
    }

    public deleteCustomView(parent: string, request: common.CustomView) {
        this.store.dispatch(
            CustomViewsUiActions.deleteCustomView({ parent, request })
        );
    }

    public setSelectedView(payload: common.CustomView) {
        this.store.dispatch(CustomViewsUiActions.setSelectedView({ payload }));
    }

    public reset() {
        this.store.dispatch(CustomViewsUiActions.reset());
    }
}
